import React from 'react';

export default function MeModeToggle({ value, onChange, label = 'Me mode' }) {
	const handleToggle = () => {
		if (onChange) onChange(!value);
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			handleToggle();
		}
	};

	const tooltipText = 'Show only the pending tasks you need to focus on.';

	return (
		<button
			type="button"
			role="switch"
			aria-checked={value}
			aria-label={label}
			data-tooltip={tooltipText}
			className={`me-mode-toggle tooltip is-tooltip-bottom${
				value ? ' is-on' : ''
			}`}
			onClick={handleToggle}
			onKeyDown={handleKeyDown}>
			<span className="me-mode-toggle-label">{label}</span>
			<span className="me-mode-toggle-dot" aria-hidden="true" />
		</button>
	);
}
